export default {
  // Hero
  'archive.hero.kicker': 'Tate Protest presenta',
  'archive.hero.title': 'EL ARCHIVO',
  'archive.hero.subtitle': 'El registro está en cinta',
  'archive.hero.accessing': 'ACCEDIENDO AL ARCHIVO DE VÍDEO_',
  'archive.hero.selectScreen': 'SELECCIONA UNA PANTALLA',
  'archive.featured.eyebrow': 'Vídeo destacado',
  'archive.featured.selectedEyebrow': 'Vídeo seleccionado',
  'archive.featured.unavailableTitle': 'Cinta destacada no disponible',
  'archive.featured.unavailableBody': 'La cinta destacada del archivo no está disponible en este momento. Usa la pared de televisores para seleccionar otra cinta.',

  // Puerta del arquitecto
  'archive.door.enter': 'Entra en la Matrix',

  // Pantallas de TV
  'archive.tv.accessDenied': 'ACCESO DENEGADO',

  // Estado de terminal + CTA (pie de página)
  'archive.status.active': 'ESTADO DEL ARCHIVO: ACTIVO',
  'archive.status.newTapes': 'NUEVAS CINTAS AÑADIDAS A MEDIDA QUE AVANZAN LOS PROCEDIMIENTOS',
  'archive.cta.description': 'Estas cintas de archivo forman parte del registro documental de Tate Protest. Para la cronología legal completa y la documentación del caso, visita directamente las páginas de los casos.',
  'archive.cta.legalTimeline': 'Cronología legal',
  'archive.cta.evidence': 'Panel de evidencia',
  'archive.cta.getInvolved': 'Participa',

  // Reproductor de vídeo
  'archive.player.subtitles': 'Subtítulos',
  'archive.player.ccOff': 'Desactivar subtítulos',
  'archive.player.ccEn': 'Subtítulos en inglés',
  'archive.player.ccEs': 'Subtítulos en español',
  'archive.player.ccDe': 'Deutsche Untertitel',
  'archive.player.archiveFootage': 'IMÁGENES DE ARCHIVO',
  'archive.player.sourcePending': 'FUENTE PENDIENTE',
  'archive.player.sourcePreparing': 'La fuente del vídeo se está preparando para su inserción en el archivo.',
  'archive.player.tape': 'CINTA',
  'archive.player.originalSource': 'Fuente original',
  'archive.player.viewSource': 'Ver fuente',
  'archive.player.copied': 'Copiado',
  'archive.player.share': 'Compartir',
  'archive.player.close': 'CERRAR ARCHIVO',
  'archive.player.rewind': 'Retroceder 10 s',
  'archive.player.forward': 'Avanzar 10 s',
  'archive.player.play': 'Reproducir video',
  'archive.player.pause': 'Pausar video',
  'archive.player.volume': 'Volumen del video',
  'archive.player.fullscreen': 'Ver en pantalla completa',

  // Categorías compartidas
  'archive.categories.investigation': 'Investigación',
  'archive.categories.newsReport': 'Reportaje',
  'archive.categories.parliamentaryDebate': 'Debate parlamentario',
  'archive.categories.legalProceedings': 'Proceso judicial',
  'archive.categories.witnessStatement': 'Declaración de testigo',
  'archive.categories.civilLitigation': 'Litigio civil',
  'archive.categories.expertCommentary': 'Comentario experto',
  'archive.categories.movementHistory': 'Historia del movimiento',
  'archive.categories.pressArchive': 'Archivo de prensa',
  'archive.categories.demonstrationArchive': 'Archivo de manifestaciones',
  'archive.categories.interview': 'Entrevista',

  // Fechas compartidas
  'archive.dates.april2022': 'Abril de 2022',
  'archive.dates.april122022': '12 de abril de 2022',
  'archive.dates.august282022': '28 de agosto de 2022',
  'archive.dates.december2022': 'Diciembre de 2022',
  'archive.dates.january192023': '19 de enero de 2023',
  'archive.dates.january2024': 'Enero de 2024',
  'archive.dates.2025Present': '2025 — Presente',
  'archive.dates.romanianProceedings': 'Proceso en Rumanía',
  'archive.dates.2024Present': '2024 — Presente',
  'archive.dates.2023Present': '2023 — Presente',
  'archive.dates.ongoing': 'En curso',
  'archive.dates.2022Present': '2022 — Presente',
  'archive.dates.preArrest': 'Grabación previa al arresto',
  'archive.dates.august272026': '26 de agosto de 2026',
  'archive.dates.august282026': '27 de agosto de 2026',

  // Etiquetas de casos relacionados
  'archive.related.viewRomania': 'Ver el caso de Rumanía',
  'archive.related.viewMatrix': 'Ver el ataque Matrix',
  'archive.related.viewUk': 'Ver el caso del Reino Unido',
  'archive.related.viewUs': 'Ver el caso de EE. UU.',
  'archive.related.viewJaneDoe': 'Ver el caso de Jane Doe',
  'archive.related.viewPencov': 'Ver el caso Pencov v. Doe',
  'archive.related.viewOnlineDefamation': 'Ver el caso de divulgación de cuentas contra X',
  'archive.related.viewEvidence': 'Ver la evidencia',
  'archive.related.aboutTates': 'Sobre los Tate',
  'archive.related.getInvolved': 'Participa',
  'archive.related.viewArchive': 'Ver el archivo',

  // Vídeo 001
  'archive.videos.latest-development.title': 'Redada del DIICOT captada por el CCTV de Andrew Tate — Abril de 2022',
  'archive.videos.latest-development.description': 'El CCTV del propio recinto de Andrew Tate capta a agentes rumanos del DIICOT registrando la propiedad en abril de 2022. Los agentes incautaron ordenadores, cámaras y todos los dispositivos electrónicos del recinto como parte de la investigación penal inicial.',

  // Vídeo 002
  'archive.videos.diicot-seizure.title': 'El DIICOT lo incautó todo — Andrew Tate, 12 de abril de 2022',
  'archive.videos.diicot-seizure.description': 'Andrew Tate documenta que el DIICOT incautó todos los ordenadores, cámaras y dispositivos electrónicos del recinto. Imágenes personales que muestran las secuelas de la redada de abril de 2022: cada dispositivo confiscado por las autoridades rumanas.',

  // Vídeo 003
  'archive.videos.andrew-schulz-cancelled.title': 'Andrew Schulz habla de la cancelación de Andrew Tate — 28 de agosto de 2022',
  'archive.videos.andrew-schulz-cancelled.description': 'El cómico Andrew Schulz comenta la cancelación de Andrew Tate en agosto de 2022. Schulz analiza la campaña de desplatformización, las prohibiciones coordinadas en las redes sociales y las implicaciones más amplias para la libertad de expresión y la censura digital.',

  // Vídeo 004
  'archive.videos.bloomberg-arrest.title': 'Bloomberg News — Andrew Tate detenido en Rumanía por sospechas de trata y violación',
  'archive.videos.bloomberg-arrest.description': 'Según se informa, el influencer de redes sociales Andrew Tate ha sido detenido en Rumanía por sospechas de trata de personas y violación. El ex kickboxer fue retenido junto a su hermano, Tristan, y otros dos sospechosos mientras registraban su casa en la capital, Bucarest.',

  // Vídeo 005
  'archive.videos.uk-case.title': 'Cámara de los Comunes del Reino Unido — Debate «Abordando la misoginia en las escuelas», 19 de enero de 2023',
  'archive.videos.uk-case.description': 'Debate oficial de la Cámara de los Comunes del Reino Unido titulado «Tackling Misogyny in Schools» (Abordando la misoginia en las escuelas). Los parlamentarios debatieron específicamente la influencia de Andrew Tate sobre los chicos en edad escolar, citando las preocupaciones planteadas por profesores de todo el país sobre su contenido llegando a los niños en las aulas. Transcripción oficial completa disponible a través de Hansard.',

  // Vídeo 006
  'archive.videos.cctv-footage.title': 'IMÁGENES DE CCTV \u2014 Abril de 2022',
  'archive.videos.cctv-footage.description': 'CCTV del recinto de abril de 2022 que muestra a Girl A y Girl B entrando y saliendo libremente de la propiedad de los Tate. Las imágenes documentan que las dos mujeres entraban y salían del recinto por voluntad propia, sin restricciones visibles.',

  // Vídeo 007
  'archive.videos.victim-doe-3.title': 'Víctima Doe 3 — Una mujer señalada como víctima niega la victimización y alega corrupción',
  'archive.videos.victim-doe-3.description': 'Una mujer señalada como víctima en el caso rumano declara públicamente que no es víctima. Es una de las cuatro mujeres que han denunciado corrupción en los procedimientos rumanos que involucran a Andrew y Tristan Tate. Su declaración cuestiona la premisa fundacional de que todas las denunciantes nombradas fueran en realidad víctimas.',

  // Vídeo 008
  'archive.videos.pencov-statement.title': 'Iasmina Pencov \u2014 Declaración \u00abNo soy una víctima\u00bb \u2014 Enero de 2024',
  'archive.videos.pencov-statement.description': 'Iasmina Pencov, la demandante nombrada en Pencov v. Doe, afirma en un video de enero de 2024 que no es víctima de los hermanos Tate y que no quiere tener nada que ver con la fiscalía.',

  // Vídeo 009
  'archive.videos.online-defamation.title': 'Tate contra X Corp. — Divulgación de cuentas',
  'archive.videos.online-defamation.description': 'Una orden corregida firmada desestimó sin perjuicio la demanda enmendada de descubrimiento contra X. La información del secretario mostró el caso abierto el 4 de octubre de 2026; la lista devuelta del expediente X llega hasta el 11 de septiembre y no establece el cumplimiento posterior del plazo de enmienda ni una desestimación definitiva con perjuicio.',

  // Vídeo 010
  'archive.videos.legal-analysis.title': 'Análisis y comentario legal',
  'archive.videos.legal-analysis.description': 'Análisis legal experto de los procedimientos de los Tate. Comentarios de abogados, desgloses procesales y reportajes de investigación sobre la batalla legal multijurisdiccional.',

  // Vídeo 011
  'archive.videos.the-evidence.title': 'El panel de evidencia',
  'archive.videos.the-evidence.description': 'Evidencia documentada y hechos clave. Documentos de fuentes primarias, escritos judiciales, entradas de la cronología y registros públicos verificados en todas las jurisdicciones.',

  // Vídeo 012
  'archive.videos.tate-protest-history.title': 'Historia de Tate Protest',
  'archive.videos.tate-protest-history.description': 'La historia de Tate Protest como plataforma independiente de defensa. Orígenes, crecimiento, hitos clave y el esfuerzo impulsado por la comunidad para documentar y compartir información veraz.',

  // Vídeo 013
  'archive.videos.media-coverage.title': 'Archivo de cobertura mediática',
  'archive.videos.media-coverage.description': 'Recopilación de cobertura mediática internacional. Emisiones de noticias, entrevistas, ruedas de prensa y reportajes periodísticos sobre los procedimientos legales de los Tate y la respuesta pública.',

  // Vídeo 014
  'archive.videos.protest-footage.title': 'Imágenes de la protesta',
  'archive.videos.protest-footage.description': 'Manifestaciones pacíficas y concentraciones públicas documentadas. Imágenes de protestas, mítines y eventos públicos de defensa en apoyo de los hermanos Tate en varios países.',

  // Vídeo 015
  'archive.videos.tate-jack-neel.title': 'La última entrevista de Andrew Tate — Podcast con Jack Neel — Grabada en caso de arresto',
  'archive.videos.tate-jack-neel.description': 'Andrew Tate se sienta con Jack Neel para lo que se describió como su «última entrevista»: un episodio de podcast pregrabado destinado a publicarse en caso de su arresto. Tate habla con franqueza sobre los procedimientos legales, la campaña coordinada en su contra y su mensaje a sus seguidores si llegara a ser detenido.',

  // Vídeo 016
  'archive.videos.vivian-belt-video-statement.title': 'Vivian habla sobre el «video del cinturón» filtrado',
  'archive.videos.vivian-belt-video-statement.description': 'En esta declaración en video, Vivian afirma que las imágenes filtradas, conocidas como el «video del cinturón», mostraban un juego sexual consentido. Vivian ha sido descrita como una presunta víctima central en relación con la acusación rumana de septiembre de 2026. Este archivo presenta la declaración como su propio relato; por sí sola, no constituye una determinación judicial sobre las alegaciones.',

  // Vídeo 017
  'archive.dates.notProvided': 'Fecha de grabación no proporcionada',
  'archive.videos.disruptors-clip.title': 'Tristan habla sobre el consentimiento sexual',
  'archive.videos.disruptors-clip.description': 'Tristan Tate habla sobre el consentimiento sexual en este clip de entrevista proporcionado por el usuario con una marca de agua de Disruptors. No se han proporcionado la fecha de grabación ni el enlace de publicación original.',
  'archive.videos.miami-protest.title': 'Protesta en Miami — 27 de agosto de 2026',
  'archive.videos.miami-protest.description': 'Una manifestación pacífica a las 9:00 AM EDT en el Tribunal de EE. UU. C. Clyde Atkins, 301 North Miami Avenue, Miami, Florida 33128, seguida por la audiencia de detención a las 10:00 AM EDT.',
};